"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _get = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");
var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PolisProvider = void 0;
var json_rpc_engine_1 = require("json-rpc-engine");
var httpRequest_1 = __importDefault(require("./utils/httpRequest"));
var dialog_1 = __importDefault(require("./utils/dialog"));
var polisConnectMiddleware_1 = __importDefault(require("./polisConnectMiddleware"));
var utils_1 = require("./utils");
var metaMaskWallet_1 = __importDefault(require("./metaMaskWallet"));
var axios_1 = __importDefault(require("axios"));
var sweetalert2_1 = __importDefault(require("sweetalert2"));
var erros_1 = __importDefault(require("./erros"));
var wallectConnector_1 = __importDefault(require("./wallectConnector"));
var log_1 = __importDefault(require("./utils/log"));
var erros_2 = __importDefault(require("./erros"));
var utils_2 = require("../provider/utils");
var _nextId = 1;
var PolisProvider = /*#__PURE__*/function (_json_rpc_engine_1$Js) {
  _inherits(PolisProvider, _json_rpc_engine_1$Js);
  var _super = _createSuper(PolisProvider);
  function PolisProvider(opts, polisOauth2Client) {
    var _this;
    _classCallCheck(this, PolisProvider);
    _this = _super.call(this);
    _this._confirmUrl = '';
    _this._apiHost = '';
    _this._chainId = -1;
    _this._wallet_type = '';
    _this.swalPromise = null;
    _this._bridgeTx = false;
    _this.providerOpts = {
      apiHost: "",
      chainId: -1,
      maxAttempts: 5,
      token: ""
    };
    if (!opts.apiHost || opts.apiHost.length <= 0) {
      _this._apiHost = "https://polis.metis.io";
    } else {
      if (!opts.apiHost.endsWith('/')) {
        _this._apiHost = _this._apiHost + '/';
      }
      _this._apiHost = opts.apiHost;
    }
    _this._chainId = opts.chainId;
    _this._polisOauth2Client = polisOauth2Client;
    _this.providerOpts = opts;
    _this.initWallet();
    return _this;
  }
  _createClass(PolisProvider, [{
    key: "token",
    get: function get() {
      return this.providerOpts.token;
    }
  }, {
    key: "confirmUrl",
    get: function get() {
      return "".concat(this.apiHost, "#/oauth2/confirm");
    }
  }, {
    key: "bridgeUrl",
    get: function get() {
      return "".concat(this.apiHost, "#/oauth2/bridge");
    }
  }, {
    key: "rpcUrl",
    get: function get() {
      return "".concat(this.apiHost, "api/rpc/v1");
    }
  }, {
    key: "chainId",
    get: function get() {
      return this._chainId;
    },
    set: function set(value) {
      this._chainId = value;
    }
  }, {
    key: "apiHost",
    get: function get() {
      return this._apiHost;
    }
  }, {
    key: "walletType",
    get: function get() {
      return this._wallet_type;
    }
  }, {
    key: "request",
    value: function request(_request) {
      var _this2 = this;
      var req = {
        method: _request.method,
        params: _request.params,
        id: _nextId++,
        jsonrpc: "2.0"
      };
      var self = this;
      return new Promise(function (resolve, reject) {
        _this2.handle(req, function (err, response) {
          if (err) {
            reject(err);
          } else {
            resolve(response.result);
          }
        });
      });
    }
  }, {
    key: "connect",
    value: function connect(token) {
      var bridgeMetamask = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var needWcSession = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      this._bridgeTx = bridgeMetamask;
      this.providerOpts.token = token;
      if (needWcSession) {
        this.initWcConnector(true);
      }
      this.initWallet();
    }
  }, {
    key: "initWcConnector",
    value: function initWcConnector() {
      var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!this._wcConnector || init) {
        this._wcConnector = wallectConnector_1.default.getWalletConnector();
      }
      if (!this._wcConnector.connected) {
        this._wcConnector.createSession();
      }
    }
  }, {
    key: "initWallet",
    value: function initWallet() {
      var _this3 = this;
      var self = this;
      this.push(function (req, res, next, end) {
        return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (req.method === 'eth_chainId') {
                  res.result = self.chainId;
                  end();
                }
                if (!(req.method === 'personal_sign')) {
                  _context.next = 8;
                  break;
                }
                this.emit('debug', "signMessage: ".concat(JSON.stringify(res)));
                if (!(this._wallet_type != utils_1.WALLET_TYPES.POLIS)) {
                  _context.next = 8;
                  break;
                }
                _context.next = 6;
                return this.signMessage(req, res, this._wallet_type);
              case 6:
                res.result = _context.sent;
                end();
              case 8:
                next();
              case 9:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
      });
      if (this._polisOauth2Client) {
        this.push(function (req, res, next, end) {
          return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return this.handleRefreshTokenAsync();
                case 2:
                case "end":
                  return _context2.stop();
              }
            }, _callee2, this);
          }));
        });
      }
      this.push(this.createPolisWallet());
      this.push((0, polisConnectMiddleware_1.default)(this.providerOpts, this));
      this.push(function (req, res, next, end) {
        return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
          var _this4 = this;
          var result;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                if (req.method === 'eth_accounts') {
                  this.emit('debug', "eth_accounts => ".concat(JSON.stringify(res)));
                  result = res.result;
                  if (result.length === 2) {
                    res.result = [result[0]];
                    this._wallet_type = result[1];
                    if (this._wallet_type === 'METAMASK') {
                      metaMaskWallet_1.default.addMetamaskEventCallback(utils_1.PolisEvents.CHAIN_CHANGED_EVENT, function (chainId) {
                        _this4.emit(utils_1.PolisEvents.CHAIN_CHANGED_EVENT, chainId);
                      });
                      metaMaskWallet_1.default.addMetamaskEventCallback(utils_1.PolisEvents.ACCOUNTS_CHANGED_EVENT, function (address) {
                        _this4.emit(utils_1.PolisEvents.ACCOUNTS_CHANGED_EVENT, address);
                      });
                    } else {
                      metaMaskWallet_1.default.addMetamaskEventCallback(utils_1.PolisEvents.CHAIN_CHANGED_EVENT, null);
                      metaMaskWallet_1.default.addMetamaskEventCallback(utils_1.PolisEvents.ACCOUNTS_CHANGED_EVENT, null);
                    }
                  }
                }
                if (req.method === 'personal_sign') {
                  res.result = res.result.signMsg;
                }
                end();
              case 3:
              case "end":
                return _context3.stop();
            }
          }, _callee3, this);
        }));
      });
    }
  }, {
    key: "createPolisWallet",
    value: function createPolisWallet() {
      var _this5 = this;
      return (0, json_rpc_engine_1.createAsyncMiddleware)(function (req, res, next) {
        return __awaiter(_this5, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                if (!(req.method == 'eth_sendTransaction')) {
                  _context4.next = 6;
                  break;
                }
                _context4.next = 3;
                return this.confirmTrans(req, res);
              case 3:
                this.emit(utils_1.PolisEvents.TX_CONFIRM_EVENT, Object.assign({}, {
                  action: 'after confirmTrans'
                }, res));
                _context4.next = 7;
                break;
              case 6:
                next();
              case 7:
              case "end":
                return _context4.stop();
            }
          }, _callee4, this);
        }));
      });
    }
  }, {
    key: "confirmTrans",
    value: function confirmTrans(req, res) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var walletType, estimateTx, sendTx, confirmData, postData, savedTx, metaTxHash, wcTxHash;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              walletType = "";
              _context5.prev = 1;
              _context5.next = 4;
              return this.estimatePolisTrans(req);
            case 4:
              estimateTx = _context5.sent;
              if (!(this._bridgeTx || this.walletType == utils_1.WALLET_TYPES.LOCAL || this.walletType == utils_1.WALLET_TYPES.POLIS)) {
                _context5.next = 7;
                break;
              }
              return _context5.abrupt("return", this.confirmTransBridge(req, res, estimateTx));
            case 7:
              walletType = estimateTx.walletType;
              this.emit(utils_1.PolisEvents.TX_CONFIRM_EVENT, Object.assign({}, {
                action: 'polis response estimate done'
              }, estimateTx));
              this.emit(utils_1.PolisEvents.TX_CONFIRM_DIALOG_EVENT, {
                walletType: walletType,
                action: 'open'
              });
              sendTx = estimateTx;
              if (!(sendTx != undefined && sendTx.act && sendTx.act === 'SIGN')) {
                _context5.next = 52;
                break;
              }
              log_1.default.debug("_bridgeMetamask:", this._bridgeTx);
              if (!(sendTx.walletType == 'METAMASK')) {
                _context5.next = 43;
                break;
              }
              if (!this._bridgeTx) {
                _context5.next = 37;
                break;
              }
              postData = Object.assign(sendTx, {
                txType: utils_2.TX_TYPE.SEND_TX
              });
              _context5.next = 18;
              return this.polisBridgePage(postData);
            case 18:
              confirmData = _context5.sent;
              log_1.default.debug("confirmData:", confirmData);
              if (!(typeof confirmData == 'object')) {
                _context5.next = 34;
                break;
              }
              _context5.prev = 21;
              _context5.next = 24;
              return this.saveTx(this.apiHost, this.token ? this.token : "", 'save_app_tx', confirmData, true);
            case 24:
              savedTx = _context5.sent;
              this.emit('debug', Object.assign({}, {
                action: 'save-tx'
              }, savedTx));
              if (savedTx == null) {
                savedTx = {
                  tx: confirmData,
                  status: 'SERVER_ERROR',
                  chainId: estimateTx.chainId,
                  domain: estimateTx.domain,
                  data: 'ok',
                  act: 'CREATE',
                  value: estimateTx.value
                };
                this.emit('warning', Object.assign({}, {
                  action: 'save-tx error'
                }, confirmData));
              }
              _context5.next = 33;
              break;
            case 29:
              _context5.prev = 29;
              _context5.t0 = _context5["catch"](21);
              log_1.default.warn(_context5.t0);
              this.emit('warning', Object.assign({}, {
                action: 'save-tx error'
              }, _context5.t0));
            case 33:
              this.emit('debug', Object.assign({}, {
                action: 'save-tx surccess'
              }, savedTx));
            case 34:
              res.result = confirmData.trans.txhash;
              _context5.next = 41;
              break;
            case 37:
              _context5.next = 39;
              return this.metaMaskSendTransaction(this.chainId, estimateTx);
            case 39:
              metaTxHash = _context5.sent;
              res.result = metaTxHash;
            case 41:
              _context5.next = 52;
              break;
            case 43:
              if (!(sendTx.walletType == 'WALLETCONNECT')) {
                _context5.next = 50;
                break;
              }
              _context5.next = 46;
              return this.walletConnectSendTransaction(this.chainId, estimateTx);
            case 46:
              wcTxHash = _context5.sent;
              res.result = wcTxHash;
              _context5.next = 52;
              break;
            case 50:
              res.result = '';
              res.error = erros_2.default.UNKNOW_ERROR;
            case 52:
              this.emit(utils_1.PolisEvents.TX_CONFIRM_DIALOG_EVENT, {
                walletType: walletType,
                action: 'close'
              });
              _context5.next = 60;
              break;
            case 55:
              _context5.prev = 55;
              _context5.t1 = _context5["catch"](1);
              this.emit(utils_1.PolisEvents.TX_CONFIRM_DIALOG_EVENT, {
                walletType: walletType,
                action: 'close'
              });
              res.error = _context5.t1;
              this.emit(utils_1.PolisEvents.ERROR_EVENT, _context5.t1);
            case 60:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[1, 55], [21, 29]]);
      }));
    }
  }, {
    key: "confirmTransBridge",
    value: function confirmTransBridge(req, res, estimateTx) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var walletType, confirmData, savedTx;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              walletType = this.walletType;
              this.emit(utils_1.PolisEvents.TX_CONFIRM_DIALOG_EVENT, {
                walletType: walletType,
                action: 'open'
              });
              _context6.t0 = this.walletType;
              _context6.next = _context6.t0 === utils_1.WALLET_TYPES.POLIS ? 6 : _context6.t0 === utils_1.WALLET_TYPES.LOCAL ? 6 : _context6.t0 === utils_1.WALLET_TYPES.WC ? 14 : _context6.t0 === utils_1.WALLET_TYPES.MM ? 14 : 18;
              break;
            case 6:
              if (!this.token) {
                _context6.next = 12;
                break;
              }
              _context6.next = 9;
              return this.polisConfirm(estimateTx, this.token, this.confirmUrl);
            case 9:
              confirmData = _context6.sent;
              _context6.next = 13;
              break;
            case 12:
              res.error = erros_2.default.TOKEN_IS_EMPTY;
            case 13:
              return _context6.abrupt("break", 19);
            case 14:
              _context6.next = 16;
              return this.polisBridgePage(estimateTx);
            case 16:
              confirmData = _context6.sent;
              return _context6.abrupt("break", 19);
            case 18:
              return _context6.abrupt("break", 19);
            case 19:
              if (confirmData.code == 200 && (confirmData.data.act == 'CREATE' || confirmData.data.act == "SUCCESS")) {
                res.result = confirmData.data.tx;
              } else {
                res.error = confirmData.data.message;
              }
              this.emit(utils_1.PolisEvents.TX_CONFIRM_DIALOG_EVENT, {
                walletType: walletType,
                action: 'close'
              });
              if (!(this.walletType != utils_1.WALLET_TYPES.POLIS && typeof confirmData == 'object')) {
                _context6.next = 34;
                break;
              }
              _context6.prev = 22;
              _context6.next = 25;
              return this.saveTx(this.apiHost, this.token ? this.token : "", 'save_app_tx', confirmData.data, true);
            case 25:
              savedTx = _context6.sent;
              this.emit('debug', Object.assign({}, {
                action: 'save-tx'
              }, savedTx));
              if (savedTx == null) {
                this.emit('debug', Object.assign({}, {
                  action: 'save-tx error'
                }, confirmData));
              }
              _context6.next = 34;
              break;
            case 30:
              _context6.prev = 30;
              _context6.t1 = _context6["catch"](22);
              log_1.default.warn(_context6.t1);
              this.emit('debug', Object.assign({}, {
                action: 'save-tx error'
              }, _context6.t1));
            case 34:
              _context6.next = 41;
              break;
            case 36:
              _context6.prev = 36;
              _context6.t2 = _context6["catch"](0);
              this.emit(utils_1.PolisEvents.TX_CONFIRM_DIALOG_EVENT, {
                walletType: this.walletType,
                action: 'close'
              });
              res.error = _context6.t2;
              this.emit(utils_1.PolisEvents.ERROR_EVENT, _context6.t2);
            case 41:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[0, 36], [22, 30]]);
      }));
    }
  }, {
    key: "signMessage",
    value: function signMessage(req, res, walletType) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var signMsg, postData, _signMsg;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!(this._bridgeTx || walletType == utils_1.WALLET_TYPES.LOCAL)) {
                _context7.next = 6;
                break;
              }
              postData = {
                signContent: req.params[0],
                txType: utils_2.TX_TYPE.SIGN,
                accessToken: this.token ? this.token : "",
                walletType: walletType
              };
              _context7.next = 4;
              return this.polisBridgePage(postData);
            case 4:
              signMsg = _context7.sent;
              return _context7.abrupt("return", signMsg.data);
            case 6:
              if (!(walletType == "METAMASK")) {
                _context7.next = 16;
                break;
              }
              if (metaMaskWallet_1.default.checkMetaMaskInstall()) {
                _context7.next = 10;
                break;
              }
              this.emit("error", "metamask not install.");
              return _context7.abrupt("return", Promise.reject(erros_1.default.MM_NOT_INSTALL));
            case 10:
              _context7.next = 12;
              return metaMaskWallet_1.default.signMessage(req.params[0]);
            case 12:
              signMsg = _context7.sent;
              return _context7.abrupt("return", signMsg);
            case 16:
              if (!(walletType == "WALLETCONNECT")) {
                _context7.next = 21;
                break;
              }
              this.initWcConnector();
              if (!this._wcConnector) {
                _context7.next = 21;
                break;
              }
              _signMsg = wallectConnector_1.default.signMessage(this._wcConnector, req.params[0]);
              return _context7.abrupt("return", _signMsg);
            case 21:
              return _context7.abrupt("return", Promise.reject(erros_1.default.ACCOUNT_NOT_EXIST));
            case 22:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "getChainUrl",
    value: function getChainUrl(chainId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.post('chainurl', {
                chainId: chainId
              });
            case 2:
              return _context8.abrupt("return", _context8.sent);
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "estimatePolisTrans",
    value: function estimatePolisTrans(req) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var headers, response;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              headers = {
                "Access-Token": this.token,
                "chainId": this.chainId,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              };
              this.emit('debug', Object.assign({}, {
                action: 'estimatePolisTrans request',
                'rpcUrl': this.rpcUrl
              }, req));
              _context9.next = 4;
              return httpRequest_1.default.instance.post(this.rpcUrl, req, {
                headers: headers
              });
            case 4:
              response = _context9.sent;
              this.emit('debug', Object.assign({}, {
                action: 'estimatePolisTrans response'
              }, response));
              if (!(response.status == 200 && response.data.result)) {
                _context9.next = 10;
                break;
              }
              return _context9.abrupt("return", Promise.resolve(response.data.result));
            case 10:
              return _context9.abrupt("return", Promise.reject(response.data.error));
            case 11:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "polisConfirm",
    value: function polisConfirm(tx, accessToken, confirmUrl) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var transObj, width, height, confirmWin, self;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              transObj = {
                chainId: tx.chainId,
                from: tx.from,
                to: tx.to,
                value: tx.value,
                data: tx.data,
                gasLimit: tx.gasLimit,
                gasPrice: tx.gasPrice,
                fee: tx.fee,
                feeTxt: tx.feeTxt,
                walletType: tx.walletType,
                txType: tx.txType,
                accessToken: accessToken,
                symbol: tx.symbol,
                act: tx.act,
                blsWalletOpen: tx.blsWalletOpen
              };
              width = 720;
              height = 480;
              confirmWin = dialog_1.default.fire({
                title: '<span style="font-size: 24px;font-weight: bold;color: #FFFFFF;font-family: Helvetica-Bold, Helvetica">Request Confirmation</span>',
                html: "<iframe src=\"".concat(confirmUrl, "\" style=\"width: 100%; height: ").concat(height, "px;\" frameborder=\"0\" id=\"metisConfirmIframe\"></iframe>"),
                width: "".concat(width, "px"),
                showConfirmButton: false,
                background: '#3A1319',
                didOpen: function didOpen(dom) {
                  document.getElementById('metisConfirmIframe').onload = function () {
                    document.getElementById('metisConfirmIframe').contentWindow.postMessage(transObj, confirmUrl.split('/#')[0]);
                  };
                },
                didClose: function didClose() {
                  window.postMessage({
                    status: 'ERROR',
                    code: 1000,
                    message: 'CANCEL'
                  }, window.location.origin);
                }
              });
              self = this;
              return _context10.abrupt("return", new Promise(function (resolve, reject) {
                function globalMessage(event) {
                  if (event.origin !== 'https://polis.metis.io' && event.origin !== 'https://polis-test.metis.io' && event.origin !== 'https://test-polis.metis.io' && event.origin !== 'http://localhost:1024' && event.origin + "/" != self.apiHost && event.origin !== window.location.origin) {
                    return;
                  }
                  if (event.data && event.data.status) {
                    if (event.data.status === 'ERROR' || event.data.status === 'DECLINE' || event.data.status === 'FAILED') {
                      reject(event.data);
                    } else {
                      resolve(event.data);
                    }
                    window.removeEventListener('message', globalMessage, false);
                    dialog_1.default.close(self.swalPromise);
                  }
                }
                window.addEventListener('message', globalMessage, false);
              }));
            case 6:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "polisBridgePage",
    value: function polisBridgePage(data) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var bridgeUrl, height, confirmWin, self;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              bridgeUrl = this.bridgeUrl;
              height = 0;
              if (this.providerOpts.debug) {
                height = 500;
              }
              confirmWin = dialog_1.default.fire({
                title: '',
                html: "<iframe src=\"".concat(bridgeUrl, "\" style=\"width: 100%; height: ").concat(height, "px;\" frameborder=\"0\" id=\"polisBridgeIframe\"></iframe>"),
                width: "".concat(height, "px"),
                showConfirmButton: false,
                background: '#3A1319',
                didOpen: function didOpen(dom) {
                  document.getElementById('polisBridgeIframe').onload = function () {
                    document.getElementById('polisBridgeIframe').contentWindow.postMessage(data, bridgeUrl.split('/#')[0]);
                  };
                },
                didClose: function didClose() {
                  window.postMessage({
                    status: 'ERROR',
                    code: 1000,
                    message: 'CANCEL'
                  }, window.location.origin);
                }
              });
              self = this;
              return _context11.abrupt("return", new Promise(function (resolve, reject) {
                function globalMessage(event) {
                  if (event.origin !== 'https://polis.metis.io' && event.origin !== 'https://polis-test.metis.io' && event.origin !== 'https://test-polis.metis.io' && event.origin !== 'http://localhost:1024' && event.origin + "/" != self.apiHost && event.origin !== window.location.origin) {
                    return;
                  }
                  log_1.default.debug("event confirm: ".concat(JSON.stringify(event.data)));
                  if (event.data && event.data.status) {
                    if (event.data.status === 'ERROR' || event.data.status === 'DECLINE' || event.data.status === 'FAILED') {
                      reject(event.data);
                    } else {
                      resolve(event.data);
                    }
                    window.removeEventListener('message', globalMessage, false);
                    dialog_1.default.close(self.swalPromise);
                  }
                }
                window.addEventListener('message', globalMessage, false);
              }));
            case 6:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "metaMaskSendTransaction",
    value: function metaMaskSendTransaction(chainId, tx) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var chainObj, res, savedTx;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              if (this.token) {
                _context12.next = 2;
                break;
              }
              return _context12.abrupt("return", null);
            case 2:
              _context12.next = 4;
              return this.getChainUrl(chainId);
            case 4:
              chainObj = _context12.sent;
              if (metaMaskWallet_1.default.checkMetaMaskInstall()) {
                _context12.next = 8;
                break;
              }
              this.emit("error", "metamask not install.");
              return _context12.abrupt("return", Promise.reject(erros_1.default.MM_NOT_INSTALL));
            case 8:
              _context12.next = 10;
              return metaMaskWallet_1.default.sendMetaMaskTrans(tx, chainObj);
            case 10:
              res = _context12.sent;
              if (!(res != null)) {
                _context12.next = 34;
                break;
              }
              if (!(typeof res == 'object')) {
                _context12.next = 31;
                break;
              }
              _context12.prev = 13;
              _context12.next = 16;
              return this.saveTx(this.apiHost, this.token, 'save_app_tx', res, true);
            case 16:
              savedTx = _context12.sent;
              this.emit('debug', Object.assign({}, {
                action: 'save-tx'
              }, savedTx));
              if (!(savedTx == null)) {
                _context12.next = 22;
                break;
              }
              savedTx = {
                tx: res,
                status: 'SERVER_ERROR',
                chainId: tx.chainId,
                domain: tx.domain,
                data: 'ok',
                act: 'CREATE',
                value: tx.value
              };
              this.emit('warning', Object.assign({}, {
                action: 'save-tx error'
              }, res));
              return _context12.abrupt("return", new Promise(function (resolve, reject) {
                resolve(res.trans.txhash);
              }));
            case 22:
              _context12.next = 29;
              break;
            case 24:
              _context12.prev = 24;
              _context12.t0 = _context12["catch"](13);
              log_1.default.warn(_context12.t0);
              this.emit('warning', Object.assign({}, {
                action: 'save-tx error'
              }, _context12.t0));
              return _context12.abrupt("return", Promise.resolve(res.trans.txhash));
            case 29:
              this.emit('debug', Object.assign({}, {
                action: 'save-tx surccess'
              }, savedTx));
              return _context12.abrupt("return", Promise.resolve(res.trans.txhash));
            case 31:
              return _context12.abrupt("return", new Promise(function (resolve, reject) {
                resolve(res);
              }));
            case 34:
              return _context12.abrupt("return", Promise.reject(erros_1.default.MM_ERROR));
            case 35:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this, [[13, 24]]);
      }));
    }
  }, {
    key: "walletConnectSendTransaction",
    value: function walletConnectSendTransaction(chainId, tx) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var txhash, recipt, savedTx;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              if (this.token) {
                _context13.next = 2;
                break;
              }
              return _context13.abrupt("return", Promise.reject(erros_1.default.TOKEN_IS_EMPTY));
            case 2:
              this.initWcConnector();
              if (!this._wcConnector) {
                _context13.next = 26;
                break;
              }
              _context13.next = 6;
              return wallectConnector_1.default.sendTrans(this._wcConnector, tx);
            case 6:
              txhash = _context13.sent;
              recipt = '';
              tx.domain = '';
              _context13.prev = 9;
              _context13.next = 12;
              return this.saveTx(this.apiHost, this.token, 'save_app_tx', tx, true);
            case 12:
              savedTx = _context13.sent;
              this.emit('debug', Object.assign({}, {
                action: 'save-tx'
              }, savedTx));
              if (!(savedTx == null)) {
                _context13.next = 18;
                break;
              }
              savedTx = {
                tx: txhash,
                status: 'SERVER_ERROR',
                chainId: tx.chainId,
                domain: tx.domain,
                data: 'ok',
                act: 'CREATE',
                value: tx.value
              };
              this.emit('warning', Object.assign({}, {
                action: 'save-tx error'
              }, savedTx));
              return _context13.abrupt("return", Promise.resolve(txhash));
            case 18:
              _context13.next = 24;
              break;
            case 20:
              _context13.prev = 20;
              _context13.t0 = _context13["catch"](9);
              this.emit('warning', Object.assign({}, {
                action: 'save-tx error'
              }, _context13.t0));
              return _context13.abrupt("return", Promise.resolve(txhash));
            case 24:
              this.emit('debug', Object.assign({}, {
                action: 'save-tx surccess'
              }, savedTx));
              return _context13.abrupt("return", Promise.resolve(txhash));
            case 26:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this, [[9, 20]]);
      }));
    }
  }, {
    key: "queryPolisTxAsync",
    value: function queryPolisTxAsync(chainId, tx, disableTooltip) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var headers, res, trans, toast, errMsg;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              headers = {
                'Content-Type': 'application/json',
                'Access-Token': this.token
              };
              _context14.next = 3;
              return this.handleRefreshTokenAsync();
            case 3:
              _context14.next = 5;
              return httpRequest_1.default.instance.post(this.apiHost + "/api/v1/oauth2/query_tx", {
                chainId: chainId,
                tx: tx
              }, {
                headers: headers
              });
            case 5:
              res = _context14.sent;
              if (!(res.status === 200 && res.data && res.data.code === 200)) {
                _context14.next = 10;
                break;
              }
              trans = res.data.data;
              if (trans.tx && trans.act && trans.act === 'SUCCESS' && !disableTooltip) {
                toast = sweetalert2_1.default.mixin({
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                  didOpen: function didOpen(toast) {
                    toast.addEventListener('mouseenter', sweetalert2_1.default.stopTimer);
                    toast.addEventListener('mouseleave', sweetalert2_1.default.resumeTimer);
                  }
                });
                if (trans.status && trans.status === 'SUCCEED') {
                  toast.fire({
                    icon: 'success',
                    title: 'Smart contract submit successfully'
                  });
                } else if (trans.status && trans.status === 'FAILED') {
                  toast.fire({
                    icon: 'warning',
                    title: 'Smart contract submit failed'
                  });
                }
              }
              return _context14.abrupt("return", trans);
            case 10:
              if (res.status === 200 && res.data) {
                errMsg = res.data.msg;
              }
              return _context14.abrupt("return", null);
            case 12:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
    }
  }, {
    key: "saveTx",
    value: function saveTx(apiHost, accessToken, method, data, disableDialog) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var headers, res, trans, result;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              headers = {
                'Content-Type': 'application/json',
                'Access-Token': accessToken
              };
              _context15.prev = 1;
              _context15.next = 4;
              return httpRequest_1.default.instance.post("".concat(apiHost, "api/v1/oauth2/") + method, data, {
                headers: headers
              });
            case 4:
              res = _context15.sent;
              if (!(res.status === 200 && res.data && res.data.code === 200)) {
                _context15.next = 8;
                break;
              }
              trans = res.data.data;
              return _context15.abrupt("return", Promise.resolve(trans));
            case 8:
              return _context15.abrupt("return", Promise.reject(res.data));
            case 11:
              _context15.prev = 11;
              _context15.t0 = _context15["catch"](1);
              _context15.next = 15;
              return sweetalert2_1.default.fire({
                html: '<div style=\'text-align: left;\'>The transaction was submitted successfully, but the application is having trouble with tracking the transaction status.</div>',
                showCancelButton: true,
                width: 600,
                confirmButtonText: 'Check again'
              });
            case 15:
              result = _context15.sent;
              if (!result.isConfirmed) {
                _context15.next = 20;
                break;
              }
              _context15.next = 19;
              return this.saveTx(apiHost, accessToken, method, data, disableDialog);
            case 19:
              return _context15.abrupt("return", _context15.sent);
            case 20:
              return _context15.abrupt("return", Promise.reject(_context15.t0));
            case 21:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this, [[1, 11]]);
      }));
    }
  }, {
    key: "post",
    value: function post(method, data) {
      var httpMethod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'post';
      var returnObj = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var headers, res, result, errMsg;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return this.handleRefreshTokenAsync();
            case 2:
              headers = {
                'Content-Type': 'application/json',
                'Access-Token': this.token
              };
              if (!(httpMethod === 'post')) {
                _context16.next = 9;
                break;
              }
              _context16.next = 6;
              return axios_1.default.post(this.apiHost + "api/v1/oauth2/" + method, data, {
                headers: headers
              });
            case 6:
              res = _context16.sent;
              _context16.next = 12;
              break;
            case 9:
              _context16.next = 11;
              return axios_1.default.get(this.apiHost + "api/v1/oauth2/" + method, {
                headers: headers
              });
            case 11:
              res = _context16.sent;
            case 12:
              if (!(res.status === 200 && res.data && res.data.code === 200)) {
                _context16.next = 17;
                break;
              }
              result = res.data.data;
              if (!returnObj) {
                _context16.next = 16;
                break;
              }
              return _context16.abrupt("return", Promise.resolve(res.data));
            case 16:
              return _context16.abrupt("return", Promise.resolve(result));
            case 17:
              if (res.status === 200 && res.data) {
                errMsg = res.data.msg;
              }
              return _context16.abrupt("return", Promise.reject(res.data));
            case 19:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
    }
  }, {
    key: "handleRefreshTokenAsync",
    value: function handleRefreshTokenAsync() {
      var _a;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var oauthInfo;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              if (!this._polisOauth2Client) {
                _context17.next = 6;
                break;
              }
              this.emit("debug", "refresh token");
              _context17.next = 4;
              return (_a = this._polisOauth2Client) === null || _a === void 0 ? void 0 : _a.handleRefreshTokenAsync();
            case 4:
              oauthInfo = _context17.sent;
              this.providerOpts.token = oauthInfo.accessToken;
            case 6:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
    }
  }, {
    key: "emit",
    value: function emit(type) {
      var _get2;
      var events = this._events;
      if (type == "error" && events && !events[type]) {
        this.on(type, function (args) {
          log_1.default.error(args);
        });
      }
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return (_get2 = _get(_getPrototypeOf(PolisProvider.prototype), "emit", this)).call.apply(_get2, [this, type].concat(args));
    }
  }], [{
    key: "defaultUrl",
    value: function defaultUrl() {
      return "http:/\/localhost:8545";
    }
  }]);
  return PolisProvider;
}(json_rpc_engine_1.JsonRpcEngine);
exports.PolisProvider = PolisProvider;